/**
 * @module websocket.event.handlers.bookings.booking-deleted
 */
import { store } from '../../../../state/store'
import { setBookingListUpdated } from '../../../../state/websocket.slice'

export default function handleBookingDeleted(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleBookingDeleted', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setBookingListUpdated(data))
  }
} 